export const ITAU_BOLETO_ENVIRONMENTS = ['sandbox', 'production'] as const;
export type ItauBoletoEnvironment = (typeof ITAU_BOLETO_ENVIRONMENTS)[number];

export interface ItauBoletoEntityConfigRequest {
  environment: ItauBoletoEnvironment;
  clientId: string;
  clientSecret: string;
  certificatePem?: string;
  privateKeyPem?: string;
  passphrase?: string;
}

export interface ItauBoletoEntityConfigResponse {
  entityId: string;
  entityName: string;
  environment: ItauBoletoEnvironment;
  clientId: string | null;
  hasCertificate: boolean;
  configured: boolean;
  webhookRegisteredAt: string | null;
}
